import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DistrictServices from '../../services/DistrictServices';

function AddPincode() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const cityId = searchParams.get('id');

  const [pincodeName, setPincodeName] = useState('');
  const [areaName, setareaName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      await DistrictServices.addPincode({
        code: pincodeName,
        area: areaName,
        city: cityId
      });
      navigate(`/Pincode?id=${cityId}`);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add Pin Code');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="right_col" role="main">
      <div className="page-title">
        <div className="title_left">
          <h3>Add New Pincode</h3>
        </div>
      </div>

      <div className="clearfix"></div>

      <div className="row">
        <div className="col-md-12 col-sm-12">
          <div className="x_panel">
            <div className="x_content">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="cityName">Pincode Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="pincodeName"
                    value={pincodeName}
                    onChange={(e) => setPincodeName(e.target.value)}
                
                  />
                  <label htmlFor="cityName">Area Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="areaName"
                    value={areaName}
                    onChange={(e) => setareaName(e.target.value)}
          
                  />
                </div>

                {error && <div className="alert alert-danger">{error}</div>}

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Adding...' : 'Add Pincode'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddPincode;